import { createConsumer } from '@rails/actioncable';

import { isClient } from 'lib/ssr_utils';

export default isClient ? createConsumer() : null;
